module.exports = __webpack_public_path__ + "static/carpoolchella-design-contest-header-008fc50e72fe65dcb9b28cccfc95b531.png";